import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Stack, Grid } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useMsal } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";
import { editTrack } from "../Redux/TrackSlice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));
function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    {/* <CloseIcon /> */}
                    <img src="/images/Home/close_img.png" alt="icon" className="form_close_img" />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}
BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#7500C0"),
    backgroundColor: "#7500C0",
    "&:hover": {
        backgroundColor: "#7500C0",
        color: "#fff",
    },
}));

function EditTrackPopup(props) {
    const [trackName, setTrackName] = useState();
    const [trackDesc, setTrackDesc] = useState();
    const [isTrackNameNull, setIsTrackNameNull] = useState(false);
    const [isTrackDescNull, setIsTrackDescNull] = useState(false);

    const dispatch = useDispatch();

    const handleClose = () => {
        props.setOpenEditTrack(false);
        setIsTrackNameNull(false);
        setIsTrackDescNull(false);
        setTrackName("");
        setTrackDesc("");
    };

    const saveEditHandle = () => {
        if (trackName == "") {
            setIsTrackNameNull(true);
        }
        if (trackDesc == "") {
            setIsTrackDescNull(true);
        }
        if (trackName != "" && trackDesc != "") {
            dispatch(editTrack(props?.editTrackDetails?.id, trackName, trackDesc));
            setIsTrackNameNull(false);
            setIsTrackDescNull(false);
            setTrackName("");
            setTrackDesc("");
            props.setOpenEditTrack(false);
        }
    };

    useEffect(() => {
        if (props.editTrackDetails) {
            setTrackName(props.editTrackDetails.trackName || "");
            setTrackDesc(props.editTrackDetails.trackDesc || "");
        }
    }, [props.editTrackDetails]);

    return (
        <div>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={props.openEditTrack}
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    className="popup"
                    sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                        textAlign: "center",
                        paddingBottom: "0px !important",
                    }}
                    onClose={handleClose}
                >
                    Edit Track
                </BootstrapDialogTitle>
                <DialogContent sx={{ paddingTop: "15px", width: "600px" }}>
                    <Stack sx={{ padding: "10px", marginTop: "10px" }} spacing={2}>
                        <Stack spacing={1}>
                            <Typography sx={{ fontSize: "14px" }}>
                                Track Name <span style={{ color: "red" }}>*</span>
                            </Typography>
                            <TextField
                                error={isTrackNameNull ? true : false}
                                required={isTrackNameNull ? false : true}
                                value={trackName}
                                className="coursecode-textfield"
                                size="small"
                                fullWidth
                                multiline
                                id={"outlined-required"}
                                variant="outlined"
                                onChange={(e) => {
                                    setTrackName(e.target.value);
                                }}
                                sx={{ width: "100%", fontSize: "14px !important" }}
                            />
                        </Stack>
                        <Stack spacing={1}>
                            <Typography sx={{ fontSize: "14px" }}>
                                Track Description <span style={{ color: "red" }}>*</span>
                            </Typography>
                            <TextField
                                error={isTrackDescNull ? true : false}
                                required={isTrackDescNull ? false : true}
                                value={trackDesc}
                                className="coursecode-textfield"
                                size="small"
                                fullWidth
                                multiline
                                id={"outlined-required"}
                                variant="outlined"
                                onChange={(e) => {
                                    setTrackDesc(e.target.value);
                                }}
                                sx={{ width: "100%", fontSize: "14px !important" }}
                            />
                        </Stack>
                    </Stack>
                </DialogContent>
                <DialogActions
                    sx={{ justifyContent: "center", alignItems: "center", marginBottom: "10px" }}
                >
                    <ColorButton
                        variant="contained"
                        className="cancel-button"
                        size="small"
                        sx={{ background: "white", color: "#7500C0", border: "solid 1px #7500C0" }}
                        autoFocus
                        onClick={handleClose}
                    >
                        Cancel
                    </ColorButton>
                    <ColorButton
                        variant="contained"
                        className="save-button"
                        size="small"
                        sx={{ background: "#7500C0", color: "white" }}
                        autoFocus
                        onClick={saveEditHandle}
                    >
                        Submit
                    </ColorButton>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}

export default EditTrackPopup;
